/* eslint-disable no-loop-func */
import React, { Component } from 'react'
import {  formatUploadFileData, imageSource } from 'plugin/helper';
import ModalPreviewPdf from "components/pages/modal/previewPdf";
import { FileUploader } from 'devextreme-react';

class FormDocument extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataDocument: []
        }

        this.formRef = React.createRef()
        this.modalPreviewRef = React.createRef()
    }

    onImageSource = (contentType, base64) => {        
        var imageSrc = imageSource(contentType,base64)
        return imageSrc
    }

    retrieveData = (data) => {
        if(data){
            this.setState({
                dataDocument: data
            })
        }
    }

    viewDocument = (documentType) => {
        if(documentType === 'documentIdentitas'){
            for(const value of this.state.dataDocument){
                if(value.dokumenTypeId === 1){
                    const src = imageSource(value.dokumenFileContentType, value.dokumenFile)
                    this.modalPreviewRef.current.show()
                    this.modalPreviewRef.current.retrieveData(src)
                }
            }
        }

        if(documentType === 'photoKK'){
            for(const value of this.state.dataDocument){
                if(value.dokumenTypeId === 2){
                    const src = imageSource(value.dokumenFileContentType, value.dokumenFile)
                    this.modalPreviewRef.current.show()
                    this.modalPreviewRef.current.retrieveData(src)
                }
            }
        }

        if(documentType === 'kartuPegawai'){
            for(const value of this.state.dataDocument){
                if(value.dokumenTypeId === 3){
                    const src = imageSource(value.dokumenFileContentType, value.dokumenFile)
                    this.modalPreviewRef.current.show()
                    this.modalPreviewRef.current.retrieveData(src)
                }
            }
        }
    }

    onUploadStarted = (e) => {
        var fieldName = e.component._options._optionManager._options.name
        for (var i = 0; i < e.value.length; i++) {
            var files = e.value[i]
            
            var fr = new FileReader()

            var formattedFileData

            fr.onload = (efr) => {
                formattedFileData = formatUploadFileData(efr.target.result)

                if(fieldName === 'documentIdentitas'){
                    this.setState(prevState =>({
                        dataDocument: [
                            ...prevState.dataDocument,
                            {
                                dokumenFile: formattedFileData.base64data,
                                [`dokumenFileContentType`]: formattedFileData.mime,
                                dokumenTypeId: 1
                            }
                        ]
                    }))
                }
        
                if(fieldName === 'photoKK'){
                    this.setState(prevState =>({
                        dataDocument: [
                            ...prevState.dataDocument,
                            {
                                dokumenFile: formattedFileData.base64data,
                                [`dokumenFileContentType`]: formattedFileData.mime,
                                dokumenTypeId: 2
                            }
                        ]
                    }))
                }
        
                if(fieldName === 'kartuPegawai'){
                    this.setState(prevState =>({
                        dataDocument: [
                            ...prevState.dataDocument,
                            {
                                dokumenFile: formattedFileData.base64data,
                                [`dokumenFileContentType`]: formattedFileData.mime,
                                dokumenTypeId: 3
                            }
                        ]
                    }))
                }
            }
    
            fr.readAsDataURL(files)
        }
    }

    renderDocumentIdentitas = () => {
        let dataDocs = this.state.dataDocument
        var result

        if(dataDocs.length > 0){
            for(var value of dataDocs){
                if(value.dokumenTypeId === 1){
                    result = imageSource(value.dokumenFileContentType, value.dokumenFile)
                }
            }
        }

        return result
    }
    renderphotoKK = () => {
        let dataDocs = this.state.dataDocument
        var result

        if(dataDocs.length > 0){
            for(var value of dataDocs){
                if(value.dokumenTypeId === 2){
                    result = imageSource(value.dokumenFileContentType, value.dokumenFile)
                }
            }
        }

        return result
    }
    renderkartuPegawai = () => {
        let dataDocs = this.state.dataDocument
        var result

        if(dataDocs.length > 0){
            for(var value of dataDocs){
                if(value.dokumenTypeId === 3){
                    result = imageSource(value.dokumenFileContentType, value.dokumenFile)
                }
            }
        }

        return result
    }

    removeState = () => {
        this.setState({
            dataDocument: []
        })
    }

    sendData = () => {
        let data = this.state.dataDocument
        return data
    }

    render() {
        let identitas = this.renderDocumentIdentitas()
        let npwp = this.renderphotoKK()
        let selfie = this.renderkartuPegawai()
        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-4'>
                        <FileUploader
                            accept={'image/png, image/jpeg'} 
                            uploadMode={'useForm'}
                            onValueChanged={this.onUploadStarted.bind(this)} 
                            labelText=""
                            showFileList={false}
                            name={'documentIdentitas'}
                            visible={false}
                            dialogTrigger="#btn-upload-documentIdentitas"
                        />
                        <div className="dropzone-image-container dropzone mt-5">
                                <img style={{maxWidth: '100%'}} className={`${this.state.dataDocument.length > 0 ? '' : 'd-none'}`} src={identitas} alt="Dokumen Reg Peserta"/>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <span>Dokumen Identitas</span>
                                <div>
                                    <button className="btn btn-sm btn-secondary mx-1 border-0 rounded-lg mb-0" style={{width: '40px'}} onClick={() => {this.viewDocument(`documentIdentitas`)}}><i className="far fa-eye"></i></button>
                                {/* <button className="btn btn-sm btn-secondary mx-2 border-0 rounded-lg mb-0" style={{width: '40px'}} onClick={() => {this.removeDocument('documentIdentitas')}}><i className="far fa-trash-alt"></i></button> */}
                                <button className="btn btn-sm bg-button-popup-save-dapen-default text-white ml-2 px-3 rounded-lg mb-0" id="btn-upload-documentIdentitas">Unggah</button>
                                </div>
                            </div>
                    </div>
                    <div className='col-4'>
                        <FileUploader
                            accept={'image/png, image/jpeg'} 
                            uploadMode={'useForm'}
                            onValueChanged={this.onUploadStarted.bind(this)} 
                            labelText=""
                            showFileList={false}
                            name={'photoKK'}
                            visible={false}
                            dialogTrigger="#btn-upload-photoKK"
                        />
                        <div className="dropzone-image-container dropzone mt-5">
                                <img style={{maxWidth: '100%'}} className={`${this.state.dataDocument.length > 0 ? '' : 'd-none'}`} src={npwp} alt="Dokumen Reg Peserta"/>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <span>Dokumen KK</span>
                                <div>
                                    <button className="btn btn-sm btn-secondary mx-1 border-0 rounded-lg mb-0" style={{width: '40px'}} onClick={() => {this.viewDocument(`photoKK`)}}><i className="far fa-eye"></i></button>
                                    {/* <button className="btn btn-sm btn-secondary mx-2 border-0 rounded-lg mb-0" style={{width: '40px'}} onClick={() => {this.removeDocument('photoKK')}}><i className="far fa-trash-alt"></i></button> */}
                                    <button className="btn btn-sm bg-button-popup-save-dapen-default text-white ml-2 px-3 rounded-lg mb-0" id="btn-upload-photoKK">Unggah</button>
                                </div>
                            </div>
                    </div>
                    <div className='col-4'>
                        <FileUploader
                            accept={'image/png, image/jpeg'} 
                            uploadMode={'useForm'}
                            onValueChanged={this.onUploadStarted.bind(this)} 
                            labelText=""
                            showFileList={false}
                            name={'kartuPegawai'}
                            visible={false}
                            dialogTrigger="#btn-upload-kartuPegawai"
                        />
                        <div className="dropzone-image-container dropzone mt-5">
                                <img style={{maxWidth: '100%'}} className={`${this.state.dataDocument.length > 0 ? '' : 'd-none'}`} src={selfie} alt="Dokumen Reg Peserta"/>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <span>Dokumen Foto Kartu Pegawai</span>
                                <div>
                                    <button className="btn btn-sm btn-secondary mx-1 border-0 rounded-lg mb-0" style={{width: '40px'}} onClick={() => {this.viewDocument(`kartuPegawai`)}}><i className="far fa-eye"></i></button>
                                    {/* <button className="btn btn-sm btn-secondary mx-2 border-0 rounded-lg mb-0" style={{width: '40px'}} onClick={() => {this.removeDocument('kartuPegawai')}}><i className="far fa-trash-alt"></i></button> */}
                                    <button className="btn btn-sm bg-button-popup-save-dapen-default text-white ml-2 px-3 rounded-lg mb-0" id="btn-upload-kartuPegawai">Unggah</button>
                                </div>
                            </div>
                    </div>
                </div>

                <ModalPreviewPdf
                        ref={this.modalPreviewRef}
                        store={this.props.store}
                />
            </React.Fragment>
        )
    }
}

export default FormDocument